import React from "react";
import { Link } from "react-router-dom";
import "./header.scss";
import Box from "@material-ui/core/Box";
import MenuIcon from "@material-ui/icons/MenuOutlined";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseTwoTone";

class Header extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isMenu: false,
    };
  }
  ChangeMenuState = () => {
    this.setState({
      isMenu: !this.state.isMenu,
    });
  };
  render() {
    return (
      <nav className={!this.state.isMenu ? "top hide" : "top shown"}>
        <div className="wrapper ">
          <Box
            // bgcolor={"primary.main"}
            className="w-100"
            color={"text.main"}
            p={0}
          >
            <div className="menu-title">گفتگو کلاب</div>
            <div className="menu-item w-100">
              <ul>
                <li>
                  <Link onClick={this.ChangeMenuState} to={"/"}>
                    خانه
                  </Link>
                </li>
                <li>
                  <Link onClick={this.ChangeMenuState} to={"/about-us"}>
                    درباره ما
                  </Link>
                </li>
                <li>
                  <Link onClick={this.ChangeMenuState} to={"/contact-us"}>
                    تماس با ما
                  </Link>
                </li>
                {/* <li>
                  <Link onClick={this.ChangeMenuState} to={"/visit"}>
                    ثبت نوبت
                  </Link>
                </li> */}
                <li>
                  <Link onClick={this.ChangeMenuState} to={"/gallery"}>
                    {" "}
                    گالری تصویر{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </Box>
        </div>
        <IconButton
          color="secondary"
          className={`CloseBtn ${
            !this.state.isMenu ? "hide" : "shown"
          } shadow-sm`}
          onClick={this.ChangeMenuState}
        >
          {this.state.isMenu ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      </nav>
    );
  }
}

export default Header;
